<template>
  <div :id="this.$route.name">
    <form @submit.prevent="this.$ValidForm(this)"></form>
    <div class="card text-center">
      <div class="card-header" :class="ThemeTitleModal">
        <ul
          class="nav nav-tabs mt-3 card-header-tabs"
          id="myTab"
          role="tablist"
          dir="rtl"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="Detail-tab"
              data-toggle="tab"
              href="#Detailtab"
              role="tab"
              aria-controls="Detailtab"
              aria-selected="true"
              >تعریف سمت ها</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="Hellp-tab"
              data-toggle="tab"
              href="#Hellp"
              role="tab"
              aria-controls="Hellp"
              aria-selected="true"
              >راهنما</a
            >
          </li>
        </ul>
      </div>
      <div class="tab-content" id="ControlerTarifSematha">
        <div
          class="tab-pane fade show active"
          id="Detailtab"
          role="tabpanel"
          aria-labelledby="Detail-tab"
        >
          <div class="container mt-3 mb-3 text-right">
            <div class="row">
              <div class="col-lg-4 col-12">
                <small>کد سمت</small>
                <input
                  @keypress="$ValidNumber($event, 9)"
                  type="number"
                  class="form-control InputText required"
                  v-model="DataAxios.Gcode"
                />
              </div>
              <div class="col-lg-8 col-12 text-right">
                <small>نام سمت</small>
                <input
                  @keypress="$ValidPersian($event, 45)"
                  type="text"
                  class="form-control InputText required"
                  v-model="DataAxios.GName"
                />
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <small>توضیحات</small>
                <textarea
                  @keypress="$ValidPersian($event, 95)"
                  type="text"
                  class="form-control"
                  rows="2"
                  v-model="DataAxios.Tozihat"
                ></textarea>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-4 col-12">
                <small>مدیر کل شعب (بالاترین سطح دسترسی)</small>
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="IsModirShoab"
                      @click="statusChk($event)"
                      v-model="IsModir"
                    />
                    <label class="custom-control-label" for="IsModirShoab"
                      >مدیر کل شعب</label
                    >
                  </div>
                </span>
              </div>
              <div class="col-md-8 col-12">
                <small>نام شعبه</small>
                <select
                  class="form-control required"
                  id="cmbShobe"
                  v-model="Shobe"
                >
                  <option value="-1">نام شعبه را انتخاب کنید</option>
                  <option
                    v-for="item in this.$store.state.TarifSematha.Listshobe"
                    :key="item.Id"
                    :value="item.Id"
                  >
                    {{ item.NameShobe }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <button-save-data
            class="mb-3 mr-2"
            :DataParanet="DataAxios"
          ></button-save-data>
        </div>
        <div
          class="tab-pane fade show"
          id="Hellp"
          role="tabpanel"
          aria-labelledby="Hellp-tab"
        >
          <div class="mt-2 mb-2 alert alert-secondary">
            [بعد از فعال کردن گزینه مورد نظر ، سیستم به صورت خودکار اطلاعات را
            ذخیره می کند.]
          </div>
        </div>
      </div>

      <div v-for="Dataa in Data" :key="Dataa.id"></div>
    </div>
  </div>
</template>
<script>
import ButtonSaveData from "../Tools/ButtonSaveData";
export default {
  components: { ButtonSaveData },
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: {},
        Method: "Get",
        Action: "DastresiDB/GettblDB",
        Token: this.$session.get("Token"),
      },
      DataAxoisAddTblGrpDb: {
        ArryfildValue: {},
        Method: "post",
        Action: "DastresiDB",
        Token: this.$session.get("Token"),
      },
      Cheked: null,
      Data: this.$store.state.TarifSematha.Data,
      DataAxios: null,
      RowsGridGrpDb: null,
    };
  },
  computed: {
    GrpDbModel: {
      get() {
        return this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid;
      },
      set(value) {
        this.$store.state.TarifSematha.DataPostTblGrpDb[0].TblDbid = value;
      },
    },
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Modir: {
      get() {
        return this.$store.state.TarifSematha.Data[0].ParentId;
      },
      set(value) {
        this.$store.state.TarifSematha.Data[0].ParentId = value;
      },
    },
    Shobe: {
      get() {
        return this.$store.state.TarifSematha.Data[0].TblShobeId;
      },
      set(value) {
        this.$store.state.TarifSematha.Data[0].TblShobeId = value;
      },
    },
    IsModir: {
      get() {
        return this.$store.state.TarifSematha.Data[0].IsModirShoab;
      },
      set(value) {
        this.$store.state.TarifSematha.Data[0].IsModirShoab = value;
      },
    },
  },
  methods: {
    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "IsModirShoab") {
        if (checkBox.checked == true) {
          this.$store.state.TarifSematha.Data[0].IsModirShoab = true;
        } else {
          this.$store.state.TarifSematha.Data[0].IsModirShoab = false;
        }
      }
    },
    // ChekeDisableTab(event){
    //   var targetId = event.currentTarget.id;
    //        var Tag = document.getElementById(targetId);
    //   var result=Tag.classList.contains("disabled");
    //   if(result==true){
    //      this.$mySweetDefault('عدم دسترسی','لطفا ابتدا اطلاعات وارد شده را ذخیره کنید ، سپس دسترسی به شما آزاد خواهد شد','warning',3000);
    //   }
    // },
  },
  mounted: function () {
    if (this.$store.state.TarifSematha.Listshobe.length == 1) {
      var element = document.getElementById("cmbShobe");
      //element.value='1'
      this.$store.state.TarifSematha.Data[0].TblShobeId =
        element.options[1].value;
    } else {
      this.$store.state.TarifSematha.Data[0].TblShobeId = -1;
      this.$GetData_Body(this.DataAxiosRow)
        .then((data) => {
          this.RowsGridGrpDb = data;
        })
        .finally(() => {
          this.$store.state.TarifSematha.RowsGridGrpDb = this.RowsGridGrpDb;
          // this.$mySweetDefaultTost(false,'بارگزاری اطلاعات موفقیت آمیز بود','success',500);
        });
    }
    // var element=document.getElementById('InformationSystem-tab')
    //          element.classList.add("disabled");
  },
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.Data.length; index++) {
      info = this.Data[index];
      list.push(info);
    }
    //console.log(list)
    this.DataAxios = list[0];
    this.$store.state.TarifSematha.Data[0].IsModirShoab = 0;
    this.$store.state.TarifSematha.Data[0].TblShobeId = 0;
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
.disabled {
  color: rgb(132, 168, 192) !important;
}
</style>
